import React, { useState } from "react";
import launchpadData from "./launchpadData";
import { useSubscription } from "../hooks/useSubscription";
import PremiumUpgradeModal from "../components/PremiumUpgradeModal";

const LaunchpadGrid = ({ onLaunchpadClick }) => {
  const { isPaid } = useSubscription();
  const [showUpgrade, setShowUpgrade] = useState(false);

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {launchpadData.map((launchpad, index) => {
          return (
            <div
              key={launchpad.id}
              className="group block bg-white border-2 border-[#5B21B6] p-6 rounded-[2rem] transition-all duration-300 text-center shadow-lg relative cursor-pointer hover:border-[#7C3AED] hover:shadow-primary/10"
              onClick={() => {
                onLaunchpadClick(launchpad);
              }}
            >
              <div className="flex flex-col items-center">
                <div className="text-[10px] font-black uppercase text-muted mb-2 self-start tracking-widest">
                  Not Started
                </div>
                <div className="w-20 h-20 mb-4 flex items-center justify-center bg-bgMain rounded-2xl p-4 group-hover:scale-110 transition-transform duration-300">
                   <div className="w-full h-full bg-primary/10 rounded-lg flex items-center justify-center text-primary font-bold text-2xl uppercase">
                     {launchpad.name.charAt(0)}
                   </div>
                </div>
                <h3 className="text-xl font-bold text-midnight mb-1 line-clamp-2 min-h-[3.5rem] flex items-center justify-center">
                  {launchpad.name}
                </h3>
                <p className="text-[10px] text-muted uppercase font-black tracking-widest mb-6">
                  {launchpad.topics?.length || 0} Topics
                </p>

                <button
                  className={`w-full py-3 rounded-xl font-black text-xs uppercase tracking-widest transition-all bg-[#5B21B6] text-white hover:bg-[#4C1D95] shadow-lg shadow-purple-200`}
                >
                  Explore Track
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <PremiumUpgradeModal
        isOpen={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        title="Unlock All Levels"
        message="Free users can access only the first 5 levels of each track. Upgrade to premium for unlimited access to all levels in Launchpad MCQs."
      />
    </>
  );
};

export default LaunchpadGrid;




